module.exports = __webpack_public_path__ + "img/liugeyi2.a9121a8d.png";